import { Text, Title, useMantineTheme } from '@mantine/core'
import React, { useEffect, useState } from 'react'

interface CountdownProps {
  futureDate?: string
  countdownMessage?: string
}

const parseDate = (date: string): string => (date.endsWith('GMT') ? date : `${date}Z`)

const Countdown: React.FC<CountdownProps> = React.memo(({ futureDate, countdownMessage = '' }) => {
  const theme = useMantineTheme()
  const [countdown, setCountdown] = useState<string>('')

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date()
      const future = futureDate ? new Date(parseDate(futureDate)) : now
      const diff = future.getTime() - now.getTime()

      if (diff <= 0) {
        setCountdown(countdownMessage)
        return
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        .toString()
        .padStart(2, '0')
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        .toString()
        .padStart(2, '0')
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)
        .toString()
        .padStart(2, '0')
      setCountdown(`${days ? `${days} :` : ''} ${hours} : ${minutes} : ${seconds}`)
    }

    const interval = setInterval(updateCountdown, 1000)

    // Initial update
    updateCountdown()

    // Cleanup interval on component unmount
    return () => clearInterval(interval)
  }, [futureDate])

  return (
    <>
      {countdown === countdownMessage ? (
        <Title
          style={{
            color: 'inherit',
            fontSize: 'inherit',
            fontFamily: 'inherit',
          }}
        >
          {countdown}
        </Title>
      ) : (
        <Text
          style={{
            fontVariantNumeric: 'tabular-nums',
            color: theme.colors.paragraph[0],
            fontSize: '14px',
          }}
        >
          {countdown}
        </Text>
      )}
    </>
  )
})

Countdown.displayName = 'Countdown'

export default Countdown
